import React from 'react';

import { ISVGPersonalProps } from 'types/svg';

export const deleteIcon: ISVGPersonalProps = {
  viewBox: '0 0 24 24',
  fill: 'currentColor',
  content: (
    <>
      <path
        d="M8.842,5.937A1.936,1.936,0,0,1,10.779,4h5.81a1.936,1.936,0,0,1,1.937,1.937V7.874H22.4a.968.968,0,0,1,0,1.937H21.364l-.838,11.756a1.936,1.936,0,0,1-1.932,1.8H8.774a1.936,1.936,0,0,1-1.932-1.8L6,9.81H4.968a.968.968,0,1,1,0-1.937H8.842Zm1.937,1.937h5.81V5.937h-5.81ZM7.946,9.81l.828,11.621h9.82L19.422,9.81Zm3.8,1.937a.971.971,0,0,1,.968.968v5.81a.968.968,0,1,1-1.937,0v-5.81A.971.971,0,0,1,11.747,11.747Zm3.874,0a.971.971,0,0,1,.968.968v5.81a.968.968,0,0,1-1.937,0v-5.81A.971.971,0,0,1,15.621,11.747Z"
        transform="translate(-1.684 -1.684)"
        fill="currentColor"
      />
      <path d="M0,0H24V24H0Z" fill="none" />
    </>
  ),
};
